import React, { useMemo } from "react"
import {
  ConsentDecision,
  DecidedConsent,
  undecided,
  UserConsent
} from "cookiesConsent/domain/consent"
import {
  JurisdictionRules,
  PrivacySignal
} from "cookiesConsent/domain/jurisdiction"
import {
  consentFromC15t,
  useC15tConsent,
  C15tConsent
} from "cookiesConsent/infrastructure/c15t/consent"

export const resolveDecision = (
  consent: C15tConsent | null
): ConsentDecision => {
  if (!consent || !consent.hasConsented) {
    return undecided
  } else {
    return new DecidedConsent(consentFromC15t(consent))
  }
}

export const resolveConsent = (
  consent: C15tConsent | null,
  rules: JurisdictionRules,
  signal: PrivacySignal
): UserConsent => {
  if (!consent || !consent.hasConsented) {
    return rules.defaultConsent(signal)
  } else {
    return consentFromC15t(consent)
  }
}

interface ConsentStrategyProps {
  rules: JurisdictionRules
  signal: PrivacySignal
  render: (consent: UserConsent) => React.ReactNode
}

export const ConsentStrategy = ({
  rules,
  signal,
  render
}: ConsentStrategyProps) => {
  const { hasConsented, categories } = useC15tConsent()
  const consent = useMemo(
    () => resolveConsent({ hasConsented, categories }, rules, signal),
    [hasConsented, categories, rules, signal]
  )

  return <>{render(consent)}</>
}
